import { render, staticRenderFns } from "./InsuranceInformationForm.vue?vue&type=template&id=caa853d8&scoped=true"
import script from "./InsuranceInformationForm.vue?vue&type=script&lang=js"
export * from "./InsuranceInformationForm.vue?vue&type=script&lang=js"
import style0 from "./InsuranceInformationForm.vue?vue&type=style&index=0&id=caa853d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa853d8",
  null
  
)

export default component.exports